import React from 'react';
import ResponsiveImage from '../../responsive-image/ResponsiveImage';
import { IonicButton } from 'ionic-ui';
import { IonIcon } from '@ionic/react';
import { close } from 'ionicons/icons';

type Props = {
  file: File;
  onRemove: (name: string) => void;
  aspectRatio: number;
  allowPreview: boolean;
};

export default ({ file, onRemove, aspectRatio, allowPreview }: Props) => {
  const [url, setUrl] = React.useState('');

  React.useEffect(() => {
    const isImage = file.type.startsWith('image/');
    if (!allowPreview || !isImage) return;

    const objectUrl = URL.createObjectURL(file);
    setUrl(objectUrl);

    // Cleanup: This runs ONLY when this specific preview is destroyed
    return () => URL.revokeObjectURL(objectUrl);
  }, [file, allowPreview]);

  return (
    <div className="space-y-2">
      {url && <ResponsiveImage src={url} aspectRatio={aspectRatio || 1} />}
      <p className="flex items-center font-medium justify-between">
        <span className="flex-1 truncate block">{file.name}</span>
        <IonicButton
          variant="ghost"
          size="sm"
          className="leading-none cursor-pointer"
          onClick={() => onRemove(file.name)}
        >
          <IonIcon icon={close} className="size-4 high-emphasis-text" />
        </IonicButton>
      </p>
    </div>
  );
};
